// js/custom-element/section/product-facet/product-facet.js

if (!customElements.get('product-facet')) {
  var ProductFacet = class extends CustomHTMLElement {
    connectedCallback() {
      this.delegate.on('pagination:page-changed', this._rerender.bind(this));
      this.delegate.on('facet:criteria-changed', this._rerender.bind(this));
      this.delegate.on('facet:abort-loading', this._abort.bind(this));
    }
    async _rerender(event) {
      history.replaceState({}, '', event.detail.url);
      this._abort();
      this.showLoadingBar();
      const url = new URL(window.location);
      url.searchParams.set('section_id', this.getAttribute('section-id'));
      try {
        this.abortController = new AbortController();
        const response = await fetch(url.toString(), { signal: this.abortController.signal });
        const responseAsText = await response.text();
        const fakeDiv = document.createElement('div');
        fakeDiv.innerHTML = responseAsText;
        this.querySelector('#facet-main').innerHTML = fakeDiv.querySelector('#facet-main').innerHTML;
        const activeFilterList = Array.from(fakeDiv.querySelectorAll('.product-facet__active-list')),
          toolbarItem = document.querySelector('.mobile-toolbar__item--filters');
        if (toolbarItem) {
          toolbarItem.classList.toggle('has-filters', activeFilterList.length > 0);
        }
        const filtersTempDiv = fakeDiv.querySelector('#facet-filters');
        if (filtersTempDiv) {
          const previousScrollTop = this.querySelector('#facet-filters .drawer__content').scrollTop;
          Array.from(this.querySelectorAll('#facet-filters-form .collapsible-toggle[aria-controls]')).forEach((filterToggle) => {
            const filtersTempDivToggle = filtersTempDiv.querySelector(`[aria-controls="${filterToggle.getAttribute('aria-controls')}"]`),
              isExpanded = filterToggle.getAttribute('aria-expanded') === 'true';
            if (filtersTempDivToggle) {
              filtersTempDivToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
              filtersTempDivToggle.nextElementSibling.toggleAttribute('open', isExpanded);
              filtersTempDivToggle.nextElementSibling.style.overflow = isExpanded ? 'visible' : '';
            }
          });
          this.querySelector('#facet-filters').innerHTML = filtersTempDiv.innerHTML;
          this.querySelector('#facet-filters .drawer__content').scrollTop = previousScrollTop;
        }
        const scrollTo = this.querySelector('.product-facet__main') || this.querySelector('.product-facet__product-list');
        requestAnimationFrame(() => {
          scrollTo.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
        this.hideLoadingBar();
      } catch (e) {
        if (e.name === 'AbortError') {
          return;
        }
      }
    }
    _abort() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }
  };
  window.customElements.define('product-facet', ProductFacet);
}
